import { ICurrencyAutocompleteGuiModel, ICurrencyGuiModel, ICurrencyRateGuiModel } from "../model/ICurrencyGuiModel";
import CurrencyService from "../service/CurrencyService";
import { ICurrencyModel } from "../service/model/ICurrencyModel";
import { BusinessLogicResult } from "./BusinessLogicResult";

export default class CurrencyBusinessLogic {

    public async getCurrencies(
        organizationId: string,
        page?: number,
        pageSize?: number,
        freeText?: string,
    ): Promise<BusinessLogicResult<ICurrencyGuiModel[]>> {


        const service = new CurrencyService();
        const result = await service.getCurrencies(organizationId, page, pageSize, freeText);

        if (result.hasErrors) {

            return new BusinessLogicResult([], result.errors);

        } else {
            let apiData: ICurrencyModel[] = result.value;

            let data = apiData.map(e => {
                return {
                    isoCode: e.isoCode,
                    name: e.name,
                    currencyCodeId: e.currencyCodeId,
                    vismaCurrencyType: e.vismaCurrencyType,
                }
            });
            return new BusinessLogicResult(data, result.errors);
        }
    };
    public async getCurrenciesAutocomplete(
        organizationId: string,
        page?: number,
        pageSize?: number,
        freeText?: string,
    ): Promise<BusinessLogicResult<ICurrencyAutocompleteGuiModel[]>> {


        const service = new CurrencyService();
        const result = await service.getCurrencies(organizationId, page, pageSize, freeText);

        if (result.hasErrors) {

            return new BusinessLogicResult([], result.errors);

        } else {
            let apiData: ICurrencyAutocompleteGuiModel[] = result.value;

            let data = apiData.map(e => {
                return {
                    name: e.name,
                    currencyCodeId: e.currencyCodeId,
                }
            });
            return new BusinessLogicResult(data, result.errors);
        }
    };

    public async getCurrencyRate(organizationId: string, codeId: number, date: Date): Promise<BusinessLogicResult<ICurrencyRateGuiModel>> {

        const service = new CurrencyService();

        const result = await service.getCurrencyRate(organizationId, codeId, date);

        const e = result.value;

        const data: ICurrencyRateGuiModel = {
            rate: e.rate
        }
        return new BusinessLogicResult(data, result.errors);
    }

}